// Company Info
export const COMPANY_INFO = {
  name: "Flowing",
  legalName: "HASE SOLUCIONES NETWORK",
  rfc: "HSN2109033B7",
  address: "PORTAL JUAREZ S/N COL CENTRO VILLA MADERO MICHOACAN",
  officeAddress: "Libramiento Oriente #178-A Col. 30 de septiembre. C.P. 61650 Tacámbaro, Michoacán",
  phone: "44 35 30 00 30",
  whatsapp: "https://wa.me/message/TB7WYEMKU3L6G1",
  email: "soporte@flowing.lat",
  supportEmail: "atencionaclientes@flowing.lat",
  hours: {
    weekdays: "Lunes a Viernes: 09:00 - 18:00",
    saturday: "Sábados: 09:00 - 14:00",
  },
};

// Legal Documents
export const LEGAL_DOCS = {
  privacyNotice: "https://drive.google.com/file/d/12xUfOGRcCmZyx4TJUe-ClDC3OViJS28X/view?usp=drive_link",
  userRights: "https://drive.google.com/file/d/1xIHlDwuqiMET4ryGK5269KIFycc0ExGz/view?usp=drive_link",
  authorization: "https://drive.google.com/file/d/1000cWqiRggDeWhXBq9ZatliQW3eWfjh6/view?usp=drive_link",
  commercialPractices: "https://drive.google.com/file/d/1Xapbx0Ezz85JS7HQ_eGSYDaIUlBbrdCp/view?usp=drive_link",
};

// Packages Data
export const PACKAGES = {
  hogar: [
    { speed: 30, price: 399, popular: false },
    { speed: 40, price: 449, popular: true },
    { speed: 50, price: 549, popular: false },
  ],
  negocios: [
    { speed: 30, price: 549, popular: false, features: ["Facturación electrónica", "Licencia de antivirus"] },
    { speed: 50, price: 649, popular: true, features: ["Facturación electrónica", "Licencia de antivirus"] },
  ],
  empresarial: [
    { speed: 100, features: ["Telefonía empresarial", "Opción Internet Simétrico"] },
    { speed: 200, features: ["Telefonía empresarial", "Opción Internet Simétrico"] },
  ],
  dedicado: [
    { speed: 50, features: ["IP pública incluida", "Seguridad Perimetral"] },
    { speed: 100, features: ["IP pública incluida", "Seguridad Perimetral"] },
    { speed: 200, features: ["IP pública incluida", "Seguridad Perimetral"] },
    { speed: 500, features: ["IP pública incluida", "Seguridad Perimetral"] },
  ],
};

// Flowing Turbo Packages
export const TURBO_PACKAGES = [
  { speed: 100, price: 649, popular: false },
  { speed: 200, price: 990, popular: true },
  { speed: 500, price: 1249, popular: false },
];

// Blog Posts Data (Fallback)
export const BLOG_POSTS = [
  {
    id: 1,
    title: "¿Por qué la fibra óptica es mejor que el cable tradicional?",
    excerpt: "Descubre las ventajas de la tecnología de fibra óptica y cómo puede mejorar tu experiencia de navegación en internet.",
    category: "Tecnología",
    date: "2026-01-15",
    image: "https://images.unsplash.com/photo-1604869515882-4d10fa4b0492?w=800&q=80",
    readTime: "5 min",
  },
  {
    id: 2,
    title: "Tips para mejorar la velocidad de tu WiFi en casa",
    excerpt: "Aprende cómo optimizar tu red WiFi para obtener el máximo rendimiento de tu conexión a internet.",
    category: "Tips",
    date: "2026-01-10",
    image: "https://images.unsplash.com/photo-1606904825846-647eb07f5be2?w=800&q=80",
    readTime: "4 min",
  },
  {
    id: 3,
    title: "Flowing Turbo: La nueva era del internet ultraveloz",
    excerpt: "Conoce nuestros nuevos planes Turbo con velocidades de hasta 500 Mbps para los usuarios más exigentes.",
    category: "Noticias",
    date: "2026-01-05",
    image: "https://images.unsplash.com/photo-1607723619497-98a79f01ba90?w=800&q=80",
    readTime: "3 min",
  },
  {
    id: 4,
    title: "Streaming en 4K: ¿Cuánta velocidad necesitas?",
    excerpt: "Te explicamos los requisitos de velocidad para disfrutar de contenido en alta definición sin interrupciones.",
    category: "Tips",
    date: "2025-12-28",
    image: "https://images.unsplash.com/photo-1691435828932-911a7801adfb?w=800&q=80",
    readTime: "4 min",
  },
];

// FAQ Data
export const FAQ_DATA = [
  {
    question: "¿Qué servicios ofrecen?",
    answer: "Ofrecemos servicios de conexión a Internet por medio de Fibra Óptica para el Hogar, Negocios, Empresas así como soluciones de Internet dedicado. También contamos con servicios de Telefonía fija, Seguridad Administrada, y consultoría tecnológica.",
  },
  {
    question: "¿Cómo funciona el Internet por Fibra Óptica?",
    answer: "La información es transmitida en forma de pulsos de luz a través de hilos de fibra de vidrio, lo que nos permite alcanzar mayores distancias y velocidades superiores a las tecnologías tradicionales.",
  },
  {
    question: "¿Es necesaria la contratación de línea telefónica?",
    answer: "No, nuestros paquetes ofrecen la opción de contratación de solo el servicio de internet o con línea telefónica fija según tus necesidades.",
  },
  {
    question: "¿Cuánto tiempo tarda la instalación?",
    answer: "Posteriormente a la firma del contrato correspondiente se levantará una orden de instalación la cual se llevará a cabo dentro de los 10 días hábiles siguientes.",
  },
  {
    question: "¿Cuáles son las formas de pago?",
    answer: "Aceptamos Transferencias, Depósitos bancarios, Pago en nuestro Centro de Atención y con Distribuidores Autorizados.",
  },
  {
    question: "Tengo problemas técnicos, ¿qué puedo hacer?",
    answer: "Puedes levantar un ticket de reporte de servicio a través del Portal de Clientes en portal.flowing.lat, comunicarte a nuestro número de atención 44 35 30 00 30, o escribirnos por WhatsApp.",
  },
  {
    question: "¿Cómo puedo cancelar mi servicio?",
    answer: "El titular deberá presentarse en las oficinas de atención, identificarse ante nuestro ejecutivo, manifestar su intención de cancelar el servicio, llenar la forma de solicitud de cancelación y firmarla.",
  },
];

// Coverage Zones with real coordinates for Tacámbaro, Michoacán
export const COVERAGE_ZONES = [
  { id: 1, name: "Centro", lat: 19.2356, lng: -101.4581, status: "active" },
  { id: 2, name: "Col. 30 de Septiembre", lat: 19.2380, lng: -101.4520, status: "active" },
  { id: 3, name: "Libramiento Oriente", lat: 19.2320, lng: -101.4480, status: "active" },
  { id: 4, name: "Col. Linda Vista", lat: 19.2410, lng: -101.4600, status: "expansion" },
  { id: 5, name: "Barrio de San Juan", lat: 19.2300, lng: -101.4620, status: "active" },
  { id: 6, name: "Col. El Cerrito", lat: 19.2280, lng: -101.4550, status: "active" },
];

// Animation variants
export const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

export const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.1 },
  },
};
